var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ClickEventListener, RenderEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class BaseChartAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onClick = new ClickEventListener();
        /** @event */
        this.onContextMenuClick = new ClickEventListener();
        /** @event */
        this.onDoubleClick = new ClickEventListener();
        /** @event */
        this.onDynamicContentRender = new RenderEventListener();
    }
    /**
     * Returns the chart data.
     */
    getData() {
        return this.state.data;
    }
    /**
     * Sets the chart data.
     *
     * @param data - The chart data.
     */
    setData(data) {
        this.setState({ ...this.state, data });
    }
    /**
     * Returns the chart height.
     */
    getHeight() {
        return this.state.height;
    }
    /**
     * Sets the chart height.
     *
     * @param height - The chart height.
     */
    setHeight(height) {
        this.setState({ ...this.state, height });
    }
    /**
     * Returns the chart legend properties.
     */
    getLegends() {
        return this.state.legends;
    }
    /**
     * Sets the chart legend properties.
     *
     * @param legends - The chart legends.
     */
    setLegends(legends) {
        this.setState({ ...this.state, legends });
    }
    /**
     * Returns the legends margin.
     */
    getLegendsMargin() {
        return this.state.legendsMargin;
    }
    /**
     * Sets the legend margin.
     *
     * @param legendsMargin - The legends margin.
     */
    setLegendsMargin(legendsMargin) {
        this.setState({ ...this.state, legendsMargin });
    }
    /**
     * Returns the chart margin.
     */
    getMargin() {
        return this.state.margin;
    }
    /**
     * Sets the chart margin.
     *
     * @param margin - The chart margin.
     */
    setMargin(margin) {
        this.setState({ ...this.state, margin });
    }
    /**
     * Returns the chart minimum height.
     */
    getMinHeight() {
        return this.state.minHeight;
    }
    /**
     * Sets the chart minimum height.
     *
     * @param minHeight - The chart minimum height.
     */
    setMinHeight(minHeight) {
        this.setState({ ...this.state, minHeight });
    }
    /**
     * Returns the chart minimum height.
     */
    getMinWidth() {
        return this.state.minHeight;
    }
    /**
     * Sets the chart minimum width.
     *
     * @param minWidth - The chart minimum width.
     */
    setMinWidth(minWidth) {
        this.setState({ ...this.state, minWidth });
    }
    /**
     * Returns if the chart legends are visible.
     */
    getShowLegends() {
        return this.state.showLegends;
    }
    /**
     * Sets if the chart legends are visible.
     *
     * @param showLegends - If the legends should be visible.
     */
    setShowLegends(showLegends) {
        this.setState({ ...this.state, showLegends });
    }
    /**
     * Returns if the chart tooltip is visible.
     */
    getShowTooltip() {
        return this.state.showTooltip;
    }
    /**
     * Sets if the chart tooltip should be visible.
     *
     * @param showTooltip - If the chart tooltip should be visible.
     */
    setShowTooltip(showTooltip) {
        this.setState({ ...this.state, showTooltip });
    }
    /**
     * Returns the chart tooltip properties.
     */
    getTooltip() {
        return this.state.tooltip;
    }
    /**
     * Sets the chart tooltip properties.
     *
     * @param tooltip - The tooltip properties.
     */
    setTooltip(tooltip) {
        this.setState({ ...this.state, tooltip });
    }
    /**
     * Returns the chart width.
     */
    getWidth() {
        return this.state.width;
    }
    /**
     * Sets the chart width.
     *
     * @param width - The chart width.
     */
    setWidth(width) {
        this.setState({ ...this.state, width });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseChartAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseChartAPI.prototype, "onContextMenuClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseChartAPI.prototype, "onDoubleClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], BaseChartAPI.prototype, "onDynamicContentRender", void 0);
export { BaseChartAPI, };
//# sourceMappingURL=base-chart-api.js.map